import { connect } from 'react-redux';
import PrivateRoute from './PrivateRoute';

function mapStateToProps({ auth }) {
  return {
    auth,
  };
}

export default connect(mapStateToProps)(PrivateRoute);
